export const StudentTestShare = {
	Private: 'private',
	Link: 'link',
	SelectedUsers: 'selected-users',
} as const

export type StudentTestShareType = (typeof StudentTestShare)[keyof typeof StudentTestShare]

export const StudentTestStatus = {
	Active: 'active',
	Archived: 'archived',
} as const

export type StudentTestStatusType = (typeof StudentTestStatus)[keyof typeof StudentTestStatus]

export const StudentTestAttemptStatus = {
	InProgress: 'in-progress',
	Completed: 'completed',
} as const

export type StudentTestAttemptStatusType = (typeof StudentTestAttemptStatus)[keyof typeof StudentTestAttemptStatus]

export const StudentTestGenerationStatus = {
	Pending: 'pending',
	Generating: 'generating',
	Completed: 'completed',
	Failed: 'failed',
} as const

export type StudentTestGenerationStatusType =
	(typeof StudentTestGenerationStatus)[keyof typeof StudentTestGenerationStatus]

export const QUESTION_COUNTS = [50, 75, 80] as const
export type QuestionCount = (typeof QUESTION_COUNTS)[number]
export type QuestionCountString = `${QuestionCount}`
export const QUESTION_COUNT_STRINGS = QUESTION_COUNTS.map(count => `${count}`) as [
	QuestionCountString,
	...QuestionCountString[],
]

export const DEFAULT_QUESTION_COUNT: QuestionCount = QUESTION_COUNTS[0]

export const DifficultyPreset = {
	Basico: 'basico',
	Estandar: 'estandar',
	Avanzado: 'avanzado',
	Experto: 'experto',
} as const

export type DifficultyPresetType = (typeof DifficultyPreset)[keyof typeof DifficultyPreset]

export const DEFAULT_DIFFICULTY_PRESET: DifficultyPresetType = DifficultyPreset.Estandar

/** Distribution: [easyPct (lvl 1-2), mediumPct (lvl 3), hardPct (lvl 4-5)] */
export const DIFFICULTY_DISTRIBUTIONS: Record<DifficultyPresetType, [number, number, number]> = {
	[DifficultyPreset.Basico]: [60, 30, 10],
	[DifficultyPreset.Estandar]: [20, 50, 30],
	[DifficultyPreset.Avanzado]: [10, 30, 60],
	[DifficultyPreset.Experto]: [0, 20, 80],
}

export const DIFFICULTY_PRESET_META: Record<DifficultyPresetType, { label: string; description: string }> = {
	[DifficultyPreset.Basico]: {
		label: 'Basico',
		description: 'Definiciones y conceptos clave',
	},
	[DifficultyPreset.Estandar]: {
		label: 'Estandar',
		description: 'Escenarios y aplicacion de normas',
	},
	[DifficultyPreset.Avanzado]: {
		label: 'Avanzado',
		description: 'Analisis comparativo y excepciones',
	},
	[DifficultyPreset.Experto]: {
		label: 'Experto',
		description: 'Casos complejos estilo judicatura',
	},
}

export const ExamStyle = {
	ExcelenciaAcademica: 'excelencia-academica',
	Judicatura: 'judicatura',
	Custom: 'custom',
} as const

export type ExamStyleType = (typeof ExamStyle)[keyof typeof ExamStyle]

export const DEFAULT_EXAM_STYLE: ExamStyleType = ExamStyle.ExcelenciaAcademica

export const EXAM_STYLE_META: Record<
	ExamStyleType,
	{ label: string; description: string; defaultDifficultyPreset: DifficultyPresetType }
> = {
	[ExamStyle.ExcelenciaAcademica]: {
		label: 'Excelencia Academica',
		description: 'Escenarios con personajes, aplicacion de normas, estilo examen de incorporacion',
		defaultDifficultyPreset: DifficultyPreset.Avanzado,
	},
	[ExamStyle.Judicatura]: {
		label: 'Judicatura',
		description: 'Matrices de clasificacion 2x2, enumeraciones, estilo Escuela Judicial',
		defaultDifficultyPreset: DifficultyPreset.Experto,
	},
	[ExamStyle.Custom]: {
		label: 'Personalizado',
		description: 'Elige tu propia dificultad y estilo',
		defaultDifficultyPreset: DifficultyPreset.Estandar,
	},
}

export type PublicExamMode = 'simulacion' | 'temario' | 'bloque' | 'tema'
export const PUBLIC_EXAM_MODE_TOPIC_TAGS: Record<PublicExamMode, string> = {
	simulacion: 'Simulación de exámenes',
	temario: 'Temario completo',
	bloque: 'Bloque temático',
	tema: 'Tema específico',
}
